function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { h } from 'preact';
import AuthView from "./AuthView.js";
import Header from "./Header.js";
import Browser from "../Browser.js";
import LoaderView from "../Loader.js";
import CloseWrapper from '../CloseWrapper.js';
import View from '../View.js';
var packageJson = {
  "version": "3.0.2"
};

function getOrigin() {
  // eslint-disable-next-line no-restricted-globals
  return location.origin;
}

function getRegex(value) {
  if (typeof value === 'string') {
    return new RegExp("^".concat(value, "$"));
  }

  if (value instanceof RegExp) {
    return value;
  }

  return undefined;
}

function isOriginAllowed(origin, allowedOrigin) {
  var patterns = Array.isArray(allowedOrigin) ? allowedOrigin.map(getRegex) : [getRegex(allowedOrigin)];
  return patterns.some(function (pattern) {
    return (pattern == null ? void 0 : pattern.test(origin)) || (pattern == null ? void 0 : pattern.test("".concat(origin, "/")));
  }); // allowing for trailing '/'
}
/**
 * Class to easily generate generic views for Provider plugins
 */


var _updateFilesAndFolders = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndFolders");

var ProviderView = /*#__PURE__*/function (_View) {
  _inherits(ProviderView, _View);

  var _super = _createSuper(ProviderView);

  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  function ProviderView(plugin, opts) {
    var _this2;

    _classCallCheck(this, ProviderView);

    _this2 = _super.call(this, plugin, opts); // set default options

    Object.defineProperty(_assertThisInitialized(_this2), _updateFilesAndFolders, {
      value: _updateFilesAndFolders2
    });
    var defaultOptions = {
      viewType: 'list',
      showTitles: true,
      showFilter: true,
      showBreadcrumbs: true
    }; // merge default options with the ones set by user

    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // Logic

    _this2.filterQuery = _this2.filterQuery.bind(_assertThisInitialized(_this2));
    _this2.getFolder = _this2.getFolder.bind(_assertThisInitialized(_this2));
    _this2.getNextFolder = _this2.getNextFolder.bind(_assertThisInitialized(_this2));
    _this2.logout = _this2.logout.bind(_assertThisInitialized(_this2));
    _this2.handleAuth = _this2.handleAuth.bind(_assertThisInitialized(_this2));
    _this2.handleScroll = _this2.handleScroll.bind(_assertThisInitialized(_this2));
    _this2.listAllFiles = _this2.listAllFiles.bind(_assertThisInitialized(_this2));
    _this2.donePicking = _this2.donePicking.bind(_assertThisInitialized(_this2)); // Visual

    _this2.render = _this2.render.bind(_assertThisInitialized(_this2)); // Set default state for the plugin

    _this2.plugin.setPluginState({
      authenticated: false,
      files: [],
      folders: [],
      directories: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });

    return _this2;
  } // eslint-disable-next-line class-methods-use-this


  _createClass(ProviderView, [{
    key: "tearDown",
    value: function tearDown() {// Nothing.
    }
    /**
     * Based on folder ID, fetch a new folder and update it to state
     *
     * @param  {string} id Folder id
     * @returns {Promise}   Folders/files in folder
     */

  }, {
    key: "getFolder",
    value: function getFolder(id, name) {
      var _this3 = this;

      return this.sharedHandler.loaderWrapper(this.provider.list(id), function (res) {
        var folders = [];
        var files = [];
        var updatedDirectories;

        var state = _this3.plugin.getPluginState();

        var index = state.directories.findIndex(function (dir) {
          return id === dir.id;
        });

        if (index !== -1) {
          updatedDirectories = state.directories.slice(0, index + 1);
        } else {
          updatedDirectories = state.directories.concat([{
            id: id,
            title: name
          }]);
        }

        _this3.username = res.username || _this3.username;

        _classPrivateFieldLooseBase(_this3, _updateFilesAndFolders)[_updateFilesAndFolders](res, files, folders);

        _this3.plugin.setPluginState({
          directories: updatedDirectories,
          filterInput: ''
        });
      }, this.handleError);
    }
    /**
     * Fetches new folder
     *
     * @param  {object} folder
     */

  }, {
    key: "getNextFolder",
    value: function getNextFolder(folder) {
      this.getFolder(folder.requestPath, folder.name);
      this.lastCheckbox = undefined;
    }
    /**
     * Removes session token on client side.
     */

  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;

      this.provider.logout().then(function (res) {
        if (res.ok) {
          if (!res.revoked) {
            var message = _this4.plugin.uppy.i18n('companionUnauthorizeHint', {
              provider: _this4.plugin.title,
              url: res.manual_revoke_url
            });

            _this4.plugin.uppy.info(message, 'info', 7000);
          }

          var newState = {
            authenticated: false,
            files: [],
            folders: [],
            directories: [],
            filterInput: ''
          };

          _this4.plugin.setPluginState(newState);
        }
      }).catch(this.handleError);
    }
  }, {
    key: "filterQuery",
    value: function filterQuery(e) {
      var state = this.plugin.getPluginState();
      this.plugin.setPluginState(_objectSpread(_objectSpread({}, state), {}, {
        filterInput: e ? e.target.value : ''
      }));
    }
    /**
     * Adds all files found inside of specified folder.
     *
     * Uses separated state while folder contents are being fetched and
     * mantains list of selected folders, which are separated from files.
     */

  }, {
    key: "addFolder",
    value: function addFolder(folder) {
      var _this5 = this;

      var folderId = this.providerFileToId(folder);

      var folders = _objectSpread({}, this.plugin.getPluginState().selectedFolders);

      if (folderId in folders && folders[folderId].loading) {
        return;
      }

      folders[folderId] = {
        loading: true,
        files: []
      };
      this.plugin.setPluginState({
        selectedFolders: _objectSpread({}, folders)
      }); // eslint-disable-next-line consistent-return

      return this.listAllFiles(folder.requestPath).then(function (files) {
        var count = 0; // If the same folder is added again, we don't want to send
        // X amount of duplicate file notifications, we want to say
        // the folder was already added. This checks if all files are duplicate,
        // if that's the case, we don't add the files.

        files.forEach(function (file) {
          var id = _this5.providerFileToId(file);

          if (!_this5.plugin.uppy.checkIfFileAlreadyExists(id)) {
            count++;
          }
        });

        if (count > 0) {
          files.forEach(function (file) {
            return _this5.addFile(file);
          });
        }

        var ids = files.map(_this5.providerFileToId);
        folders[folderId] = {
          loading: false,
          files: ids
        };

        _this5.plugin.setPluginState({
          selectedFolders: folders,
          filterInput: ''
        });

        var message;

        if (count === 0) {
          message = _this5.plugin.uppy.i18n('folderAlreadyAdded', {
            folder: folder.name
          });
        } else if (files.length) {
          message = _this5.plugin.uppy.i18n('folderAdded', {
            smart_count: count,
            folder: folder.name
          });
        } else {
          message = _this5.plugin.uppy.i18n('emptyFolderAdded');
        }

        _this5.plugin.uppy.info(message);
      }).catch(function (e) {
        var selectedFolders = _objectSpread({}, _this5.plugin.getPluginState().selectedFolders);

        delete selectedFolders[folderId];

        _this5.plugin.setPluginState({
          selectedFolders: selectedFolders
        });

        _this5.handleError(e);
      });
    }
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this6 = this;

        var authState, clientVersion, link, authWindow, handleToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.provider.ensurePreAuth();

              case 2:
                authState = btoa(JSON.stringify({
                  origin: getOrigin()
                }));
                clientVersion = "@uppy/provider-views=".concat(ProviderView.VERSION);
                link = this.provider.authUrl({
                  state: authState,
                  uppyVersions: clientVersion
                });
                authWindow = window.open(link, '_blank');

                handleToken = function handleToken(e) {
                  if (e.source !== authWindow) {
                    _this6.plugin.uppy.log('rejecting event from unknown source');

                    return;
                  }

                  if (!isOriginAllowed(e.origin, _this6.plugin.opts.companionAllowedHosts) || e.source !== authWindow) {
                    _this6.plugin.uppy.log("rejecting event from ".concat(e.origin, " vs allowed pattern ").concat(_this6.plugin.opts.companionAllowedHosts));
                  } // Check if it's a string before doing the JSON.parse to maintain support
                  // for older Companion versions that used object references


                  var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;

                  if (data.error) {
                    _this6.plugin.uppy.log('auth aborted', 'warning');

                    var uppy = _this6.plugin.uppy;
                    var message = uppy.i18n('authAborted');
                    uppy.info({
                      message: message
                    }, 'warning', 5000);
                    return;
                  }

                  if (!data.token) {
                    _this6.plugin.uppy.log('did not receive token from auth window', 'error');

                    return;
                  }

                  authWindow.close();
                  window.removeEventListener('message', handleToken);

                  _this6.provider.setAuthToken(data.token);

                  _this6.preFirstRender();
                };

                window.addEventListener('message', handleToken);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleAuth() {
        return _handleAuth.apply(this, arguments);
      }

      return handleAuth;
    }()
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var path, response, _this$plugin$getPlugi, files, folders;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                path = this.nextPagePath || null;

                if (!(this.shouldHandleScroll(event) && path)) {
                  _context2.next = 17;
                  break;
                }

                this.isHandlingScroll = true;
                _context2.prev = 3;
                _context2.next = 6;
                return this.provider.list(path);

              case 6:
                response = _context2.sent;
                _this$plugin$getPlugi = this.plugin.getPluginState(), files = _this$plugin$getPlugi.files, folders = _this$plugin$getPlugi.folders;

                _classPrivateFieldLooseBase(this, _updateFilesAndFolders)[_updateFilesAndFolders](response, files, folders);

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                this.handleError(_context2.t0);

              case 14:
                _context2.prev = 14;
                this.isHandlingScroll = false;
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 11, 14, 17]]);
      }));

      function handleScroll(_x) {
        return _handleScroll.apply(this, arguments);
      }

      return handleScroll;
    }()
  }, {
    key: "listAllFiles",
    value: function () {
      var _listAllFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path, files) {
        var _this7 = this;

        var res, moreFiles;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (files === void 0) {
                  files = null;
                }

                files = files || []; // eslint-disable-line no-param-reassign

                _context3.next = 4;
                return this.provider.list(path);

              case 4:
                res = _context3.sent;
                res.items.forEach(function (item) {
                  if (!item.isFolder) {
                    files.push(item);
                  } else {
                    _this7.addFolder(item);
                  }
                });
                moreFiles = res.nextPagePath;

                if (!moreFiles) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", this.listAllFiles(moreFiles, files));

              case 9:
                return _context3.abrupt("return", files);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listAllFiles(_x2, _x3) {
        return _listAllFiles.apply(this, arguments);
      }

      return listAllFiles;
    }()
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this8 = this;

      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi2.currentSelection;

      var promises = currentSelection.map(function (file) {
        if (file.isFolder) {
          return _this8.addFolder(file);
        }

        return _this8.addFile(file);
      });
      this.sharedHandler.loaderWrapper(Promise.all(promises), function () {
        _this8.clearSelection();
      }, function () {});
    }
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;

      if (viewOptions === void 0) {
        viewOptions = {};
      }

      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          authenticated = _this$plugin$getPlugi3.authenticated,
          didFirstRender = _this$plugin$getPlugi3.didFirstRender;

      if (!didFirstRender) {
        this.preFirstRender();
      }

      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);

      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
          files = _this$plugin$getPlugi4.files,
          folders = _this$plugin$getPlugi4.folders,
          filterInput = _this$plugin$getPlugi4.filterInput,
          loading = _this$plugin$getPlugi4.loading,
          currentSelection = _this$plugin$getPlugi4.currentSelection;

      var _this$sharedHandler = this.sharedHandler,
          isChecked = _this$sharedHandler.isChecked,
          toggleCheckbox = _this$sharedHandler.toggleCheckbox,
          recordShiftKeyPress = _this$sharedHandler.recordShiftKeyPress,
          filterItems = _this$sharedHandler.filterItems;
      var hasInput = filterInput !== '';
      var headerProps = {
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        getFolder: this.getFolder,
        directories: this.plugin.getPluginState().directories,
        pluginIcon: this.plugin.icon,
        title: this.plugin.title,
        logout: this.logout,
        username: this.username,
        i18n: this.plugin.uppy.i18n
      };
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        recordShiftKeyPress: recordShiftKeyPress,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        username: this.username,
        getNextFolder: this.getNextFolder,
        getFolder: this.getFolder,
        filterItems: this.sharedHandler.filterItems,
        filterQuery: this.filterQuery,
        logout: this.logout,
        handleScroll: this.handleScroll,
        listAllFiles: this.listAllFiles,
        done: this.donePicking,
        cancel: this.cancelPicking,
        headerComponent: Header(headerProps),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;

          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        }
      };

      if (loading) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(LoaderView, {
          i18n: this.plugin.uppy.i18n
        }));
      }

      if (!authenticated) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(AuthView, {
          pluginName: this.plugin.title,
          pluginIcon: this.plugin.icon,
          handleAuth: this.handleAuth,
          i18n: this.plugin.uppy.i18n,
          i18nArray: this.plugin.uppy.i18nArray
        }));
      }

      return h(CloseWrapper, {
        onUnmount: this.clearSelection
      }, h(Browser, browserProps));
    }
  }]);

  return ProviderView;
}(View);

export { ProviderView as default };

function _updateFilesAndFolders2(res, files, folders) {
  this.nextPagePath = res.nextPagePath;
  res.items.forEach(function (item) {
    if (item.isFolder) {
      folders.push(item);
    } else {
      files.push(item);
    }
  });
  this.plugin.setPluginState({
    folders: folders,
    files: files
  });
}

ProviderView.VERSION = packageJson.version;